<template>
    <div class="cr:flex-1 cr:px-4 cr:relative cr:flex cr:flex-col cr:justify-center cr:items-center cr:text-gray-900 cr:font-normal">
        <CompanyRegistrationV4/>
        <ErrorsModal/>
    </div>
</template>

<script setup lang="ts">
import CompanyRegistrationV4 from "@/views/CompanyRegistrationV4.vue";
import ErrorsModal from "@/components/ErrorsModal.vue";
import {useRegistrationV4Store} from "@/stores/registrationV4.ts";
import {onMounted} from "vue";

const props = defineProps({
    origin: {
        type: String,
        required: true,
    },
});

onMounted(() => useRegistrationV4Store().init(props.origin));
</script>
